module.exports = __webpack_public_path__ + "img/phone.8e317a32.png";